import React from 'react';
import { CheckCircle2, AlertTriangle } from 'lucide-react';

const TimetableSummary = ({ totalSlots = 0, assignedSlots = 0, availableSlots = 0, completionRate = 0, conflictCount = 0 }) => {
  const isComplete = completionRate === 100 && conflictCount === 0;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '14px', marginBottom: '20px' }}>
      
      {/* KPI 1: Periods This Week */}
      <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
        <div style={{ fontSize: '12px', color: '#64748B', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Periods This Week
        </div>
        <div style={{ fontSize: '24px', fontWeight: '800', color: '#0F172A', marginTop: '2px' }}>
          {totalSlots}
        </div>
        <div style={{ fontSize: '11px', color: '#94A3B8', marginTop: '2px', fontWeight: '500' }}>
          Total teaching periods available
        </div>
      </div>

      {/* KPI 2: Scheduled */}
      <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
        <div style={{ fontSize: '12px', color: '#64748B', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Scheduled
        </div>
        <div style={{ fontSize: '24px', fontWeight: '800', color: '#2563EB', marginTop: '2px' }}>
          {assignedSlots}
        </div>
        <div style={{ fontSize: '11px', color: '#94A3B8', marginTop: '2px', fontWeight: '500' }}>
          Periods already filled
        </div>
      </div>

      {/* KPI 3: Empty Periods */}
      <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
        <div style={{ fontSize: '12px', color: '#64748B', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Empty Periods
        </div>
        <div style={{ fontSize: '24px', fontWeight: '800', color: availableSlots > 0 ? '#F59E0B' : '#10B981', marginTop: '2px' }}>
          {availableSlots}
        </div>
        <div style={{ fontSize: '11px', color: '#94A3B8', marginTop: '2px', fontWeight: '500' }}>
          Still available for scheduling
        </div>
      </div>

      {/* KPI 4: Timetable Ready */}
      <div style={{ background: 'white', border: '1px solid #E2E8F0', borderRadius: '12px', padding: '14px 16px', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
        <div style={{ fontSize: '12px', color: '#64748B', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
          Timetable Ready
        </div>
        <div style={{ fontSize: '24px', fontWeight: '800', color: isComplete ? '#166534' : '#2563EB', marginTop: '2px' }}>
          {completionRate}%
        </div>
        <div style={{ fontSize: '11px', color: '#94A3B8', marginTop: '2px', fontWeight: '500' }}>
          Overall scheduling progress
        </div>
      </div>

      {/* KPI 5: Schedule Issues */}
      <div style={{ 
        background: conflictCount > 0 ? '#FEF2F2' : '#F0FDF4', 
        border: conflictCount > 0 ? '1px solid #FCA5A5' : '1px solid #BBF7D0', 
        borderRadius: '12px', 
        padding: '14px 16px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)' 
      }}>
        <div style={{ fontSize: '12px', color: conflictCount > 0 ? '#991B1B' : '#166534', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.04em', display: 'flex', alignItems: 'center', gap: '4px' }}>
          {conflictCount > 0 ? <AlertTriangle size={14} color="#DC2626" /> : <CheckCircle2 size={14} color="#166534" />}
          Schedule Issues
        </div>
        <div style={{ fontSize: '18px', fontWeight: '800', color: conflictCount > 0 ? '#DC2626' : '#166534', marginTop: '4px' }}>
          {conflictCount > 0 ? `${conflictCount} Issues` : '✓ No Schedule Issues'}
        </div>
        <div style={{ fontSize: '11px', color: conflictCount > 0 ? '#B91C1C' : '#15803D', marginTop: '2px', fontWeight: '500' }}>
          {conflictCount > 0 ? 'Teacher or quota conflict found' : 'Teacher schedules are valid'}
        </div>
      </div>

    </div>
  );
};

export default TimetableSummary;
